import type { FC, SVGProps } from "react";

/** `circle-check-big` — filled check-in-circle glyph, Figma `Component 7/circle-check-big` (node 437:7695). */
export const CircleCheckBigIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M21.801 10A10 10 0 1 1 17 3.335" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m9 11 3 3L22 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
